<template>
    <div>
        <div>
            <button size="sm" v-b-tooltip.hover.top :title="`${status != null && status.colaborador ? status.colaborador.name +' / '+status.situacao.nome : ''}`" class="btn btn-outline-secondary btn-sm" :style="{'background-color': status != null && status.situacao ? status.situacao.cor : '', 'color': status != null && status.situacao ? 'white' : '' }"
                @click="$bvModal.show(`modal-checklist-item-colaborador-${item_id}`)"  >{{status != null && status.colaborador ? status.colaborador.name.split(/\s/)
                                        .reduce(
                                            (response, word) => (response += word.slice(0, 1)),
                                            ""
                                        )
                                        .substring(0, 2) : 'Colaborador' }}</button>
            <b-button size="sm" variant="outline-secondary"
                @click="$bvModal.show(`modal-checklist-item-colaborador-${item_id}`)">{{status != null && status.inicio ?  moment(status.inicio).format('DD/MM/YYYY') : 'Inicio' }}</b-button>
            <b-button size="sm" variant="outline-secondary"
                @click="$bvModal.show(`modal-checklist-item-colaborador-${item_id}`)">{{status != null && status.inicio ?  moment(status.fim).format('DD/MM/YYYY') : 'Fim' }}</b-button>
            <b-button size="sm" variant="outline-secondary"
                @click="$bvModal.show(`modal-checklist-item-colaborador-${item_id}`)">{{status != null && status.dias ?  status.dias + ' dias' : 'Dias'}}</b-button>
            <button class="btn btn-outline-secondary btn-sm"  :style="{'background-color': status != null && status.status ? status.status.cor : '', 'color': status != null && status.status ? status.status.text: ''}"
                @click="$bvModal.show(`modal-checklist-item-colaborador-${item_id}`)">{{status != null && status.status ?  status.status.status_name : 'Vencimento'}}</button>
        </div>
        <modal size="md" :id="`modal-checklist-item-colaborador-${item_id}`" form="form-set-item-colaborador"
            :title="`Defenir Status do Item ${name}`" :btn_save="true">
            <StatusItem :status="status" :tarefa_checklist_item_id="item_id" @onSubmit="onSubmit"></StatusItem>

        </modal>
    </div>
</template>
<script>
import StatusItem from "./checklist/StatusItem.vue"
export default {
    components: { StatusItem },
    props: {
        status: null,
        item_id: Number,
        name: String,
    },
    methods: {
        onSubmit() {
            this.$emit("updateItem");
        }

    }



}
</script>
